export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('../partials-html/typography.html')
    };
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/partials-js/typography.js